













import Vue, {PropType} from 'vue'
import {Observer} from 'mobx-vue'

import {UtilityItem} from '../../stores/UtilityBar'

import Popper from './Popper.vue'

export default Observer(Vue.extend({
    data() { return {
        open: false
    }},
    components: {
        Popper
    },
    props: {
        item: Object as PropType<UtilityItem>
    },
    methods: {
        handleClick() {
            this.open = !this.open
        },
        close() {
            this.open = false
        },
        key() {
            return Date.now()
        }
    }
}))
